import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

import { ButtonAction, ACTION_BUTTON_TYPE_DELETE } from '../ButtonAction'

const StyledContainer = styled.div`
  padding: 16px;
 
`

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #f7f7f7;
`

const StyledTitle = styled.p`
  text-transform: uppercase;
  font-size: 15px;
  padding-top: 3px;
  font-weight: 500;
  margin-bottom: 15px;
`

const StyledEditContainer = styled.div``

export const FormBuilderEditPanel = ({
  className,
  children,
  title,
  onClickDelete
}) => {
  return (
    <StyledContainer className={className}>
      <StyledHeader>
        <StyledTitle>{title}</StyledTitle>
        <StyledEditContainer>
          <ButtonAction
            type={ACTION_BUTTON_TYPE_DELETE}
            onClick={onClickDelete}
          />
        </StyledEditContainer>
      </StyledHeader>

      {children}
    </StyledContainer>
  )
}

FormBuilderEditPanel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
  onClickDelete: PropTypes.func
}
